/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Bean } from '@dataplace.ai/ui-components/molecules'
import { TableSpan } from '../../ChainBenchmark.styles'

interface AnalysedVariableTableRowProps {
  variable: string
  value: number
  deviationFromAverage: number
  averageChainValue: number
}

interface AnalysedVariableTooltipTextProps {
  variable: string
  deviationFromAverage: number
}

function useGenerateAnalysedVariablesContentRow() {
  const { t } = useTranslation()

  const generateAnalysedVariableTooltipText = (({
    variable, deviationFromAverage,
  }: Pick<AnalysedVariableTooltipTextProps, 'variable' | 'deviationFromAverage'>) => {
    const upperOrLowerTranslation = deviationFromAverage > 0 ? t('generic.fem.upper') : t('generic.fem.lower')

    return `
      ${t('placeme.chain_benchmark.analysed_variables.bean_tooltip_1')}
      ${variable}
      ${t('placeme.chain_benchmark.analysed_variables.bean_tooltip_2')}
      ${' '}
      ${Math.abs(deviationFromAverage)}%
      ${' '}
      ${upperOrLowerTranslation}
      ${' '}
      ${t('placeme.chain_benchmark.analysed_variables.bean_tooltip_3')}
    `
  })

  const generateAnalysedVariablesContentRow = ({
    variable, value, deviationFromAverage, averageChainValue,
  }: AnalysedVariableTableRowProps) => {
    const tooltipText = generateAnalysedVariableTooltipText({
      variable,
      deviationFromAverage,
    })

    return [
      <TableSpan
        key={variable}
        $left
      >
        {variable}
      </TableSpan>,
      <TableSpan key={`${variable}_value`}>
        {value}
      </TableSpan>,
      <TableSpan key={`${variable}_deviationFromAverage`}>
        <Bean
          tooltipMaxWidth='320px'
          tooltipText={tooltipText}
          value={deviationFromAverage}
        />
      </TableSpan>,
      <TableSpan key={`${variable}_averageChainValue`}>
        {averageChainValue}
      </TableSpan>,
    ]
  }

  return {
    generateAnalysedVariablesContentRow,
  }
}

export default useGenerateAnalysedVariablesContentRow
